import {
  QtableCustomSlotTopRight,
  Info,
  MemberPersonalInfo,
  BasicModal,
  LayoutModal,
  BasicForm,
  EmptyList,
  CopyText,
  Loader,
  DecorationBlock,
  ErrorsModal,
  GeneralHeader,
  MemberSearchField,
  CWSearchField,
} from 'src/application/global/components'

export default [
  QtableCustomSlotTopRight,
  Info,
  MemberPersonalInfo,
  BasicModal,
  LayoutModal,
  BasicForm,
  EmptyList,
  CopyText,
  Loader,
  DecorationBlock,
  ErrorsModal,
  GeneralHeader,
  MemberSearchField,
  CWSearchField,
]
